import React, {
  useState,
  useMemo,
  Fragment,
  memo,
  useEffect,
  useCallback,
  useRef,
} from "react";
import Countdown from "react-countdown";
import _ from "lodash";
import {
  useTable,
  usePagination,
  useFilters,
  useGlobalFilter,
  useSortBy,
  useRowSelect,
} from "react-table";
import { useSelector } from "react-redux";
import classNames from "classnames";
import { format } from "date-fns";
import Swal from "sweetalert2";
import { faAngleUp, faAngleDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import LoadingMutation from "../Loading/LoadingMutation";
import { checkRole } from "../../utils/role";
import Select from "react-select";
import ReactExport from "react-data-export";

// CONTEXT
import { SearchBarContext } from "../../context/SearchBarContext";
import { EmitterStatus } from "../../event";

// COMPONENTS
import MoneyDatePicker from "../MoneyDatePicker";
import PrevPage from "../../components/Pagination/PrevPage";
import NumberPage from "../../components/Pagination/NumberPage";
import NextPage from "../../components/Pagination/NextPage";
import SelectRows from "../../components/Pagination/SelectRows";
// import SearchTable from "../Search/SearchTable";
import Pencil from "../../components/Icon/Pencil";

// UTILS
import { pad, getCurrentLocalDateTime } from "../../utils/getLocalDateTime";

// OTHER
import numeral from "numeral";

// AWS
import { S3Image } from "aws-amplify-react";
import { API, Auth, Storage } from "aws-amplify";
import Cancel from "components/Icon/Cancel";
import Check from "components/Icon/Check";
import { calPayPerMonth } from "../../utils/calculator";
import axios from "axios";

const baseApiDopa = "https://dopa-api-public.moneyhubservice.com";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

export const ExportContactBook = ({ citizenid }) => {
  const [contactList, setContactList] = useState([]);
  const [loadingBook, setLoadingBook] = useState(false);
  const [isClick, setIsClick] = useState(false);

  useEffect(() => {
    if (isClick) {
      const docContact = document.getElementById("contactBook");
      docContact.click();
    }
  }, [isClick]);

  const createDataWithStyle = (data = []) => {
    var result = [];
    const borders = {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" },
    };

    const style = {
      font: { sz: 14 },
      alignment: { vertical: "center", horizontal: "center" },
      border: borders,
    };

    for (let i = 0; i < data.length; i++) {
      result.push([
        {
          value: data[i]?.fullname,
          style,
        },
        {
          value: data[i]?.phone_number,
          style,
        },
      ]);
    }
    return result;
  };

  const style = {
    font: { sz: 16, name: "Cordia New" },
    alignment: { vertical: "center", horizontal: "center" },
  };

  const sameColumn = [
    {
      title: "ชื่อ",
      width: { wch: 38 },
      style,
    },
    {
      title: "เบอร์โทร",
      width: { wch: 38 },
      style,
    },
  ];

  const multiDataSet = [
    {
      columns: sameColumn,
      data: createDataWithStyle(contactList),
    },
  ];

  const onClickExportContactBook = async () => {
    try {
      setLoadingBook(true);
      window.open(`/contactBook/${citizenid}`, "_blank");
      // const data = await API.get("MoneyHubAdmin", `/contactBook/${citizenid}`);
      // setContactList(data?.contactList);
      // setIsClick(true);
    } catch (error) {
      alert("ไม่สามารถ export ข้อมูลได้");
    } finally {
      setLoadingBook(false);
    }
  };

  return (
    <div className="flex items-center">
      <ExcelFile
        filename={`CONTACT_BOOK_${format(new Date(), "yyyy-MM-dd")}`}
        element={<button id="contactBook" hidden></button>}
      >
        <ExcelSheet dataSet={multiDataSet} name="CONTACT BOOK"></ExcelSheet>
      </ExcelFile>
      <div>สมุดโทรศัพท์</div>
      <button
        disabled={loadingBook}
        onClick={onClickExportContactBook}
        className={classNames("ml-2 px-2 rounded text-sm", {
          "cursor-not-allowed bg-gray-400": loadingBook,
          "bg-green-500 text-white cursor-pointer": !loadingBook,
        })}
      >
        {"Export"}
      </button>
    </div>
  );
};

const getDefaultPayDate = (days = 5) => {
  let result = new Date();
  result.setDate(result.getDate() + days);
  return result;
};

const IndeterminateCheckbox = React.forwardRef(
  ({ onChange, id, selectedFlatRows, flatRows, ...rest }, ref) => {
    useEffect(() => {
      const getIdAll = document.getElementById("ALL");
      if (selectedFlatRows?.length > 0) {
        const newRows = flatRows
          .map((row) => {
            // if (
            //   row.original.loan_status !== "อนุมัติ" &&
            //   row.original.loan_status !== "ไม่ผ่าน"
            // ) {
            //   if (row.original.fileBuro) {
            return row;
            //   }
            // }
          })
          .filter((row) => row);
        getIdAll.checked = newRows.length === selectedFlatRows.length;
        getIdAll.indeterminate = newRows.length !== selectedFlatRows.length;
        return;
      }
      getIdAll.indeterminate = false;
      getIdAll.checked = false;
    }, [selectedFlatRows]);

    return (
      <>
        <input
          type="checkbox"
          id={id}
          onChange={onChange}
          {...rest}
          style={{ width: "20px", height: "20px" }}
        />
      </>
    );
  }
);

const PathOptimized = ({ degree, index, item, rotate, canRotate }) => {
  return (
    <div>
      <S3Image
        preview="true"
        imgKey={item}
        className={"w-full"}
        style={{ transform: "rotate(" + degree[index] + "deg)" }}
      />
      {canRotate ||
        (false && (
          <div className="flex px-4 my-2 flex-row justify-between w-full">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-8 w-8"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              onClick={() => rotate(index, -90)}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M7 16l-4-4m0 0l4-4m-4 4h18"
              />
            </svg>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-8 w-8"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              onClick={() => rotate(index, 90)}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M17 8l4 4m0 0l-4 4m4-4H3"
              />
            </svg>
          </div>
        ))}
    </div>
  );
};

const Gallery = ({ paths, canRotate = false, max = "grid-cols-4 " }) => {
  const [degree, setDegree] = useState([]);

  useEffect(() => {
    setDegree(Array(20).fill(0));
  }, []);

  const rotate = (index, change = 0) => {
    let temp = [...degree];
    temp[index] = temp[index] + change;
    if (temp[index] < 0) temp[index] = 270;
    if (temp[index] >= 360) temp[index] = 0;
    // alert("หมุนไปที่ " +temp[index] + " องศา")
    setDegree(temp);
  };

  if (paths?.length == undefined || paths?.length < 1) return <div></div>;

  return (
    <div className={"grid grid-cols-1 md:grid-cols-2  gap-4 lg:" + max}>
      {paths?.length &&
        paths?.map((item, index) => {
          return (
            <PathOptimized
              item={item}
              index={index}
              rotate={rotate}
              canRotate={canRotate}
              degree={degree}
            />
          );
        })}
    </div>
  );
};

const Row = ({ row, i, value, getData, query }) => {
  const { user } = useSelector((state) => state.initializeApp);

  const [showModal, setShowModal] = useState(false);
  const [updateLoading, setUpdateLoading] = useState(false);
  const [status, setStatus] = useState("");
  const [form, setForm] = useState({
    remark: "",
    reason: "" || value.reason,
    fileBuro: "" || value.originalBuro,
    referal_one: "" || value.referal_one,
    referal_two: "" || value.referal_two,
    paydate: getDefaultPayDate(),
    attachments: [],
    attachmentViews: [],
    bankBrachCode: "" || value.bankBrachCode,
  });
  const [oriAttachments, setOriAttachments] = useState([]);
  const [oriAttachmentLoan, setOriAttachmentLoan] = useState([]);
  const [checkCreate, setCheckCreate] = useState(false);
  const [loadingSaveAttchment, setLoadingSaveAttachment] = useState(false);
  const [loadingEmail, setLoadingEmail] = useState(false);
  const [checkEdit, setCheckEdit] = useState(false);
  const [interestRate, setInterestRate] = useState(0);
  const [loadingCheck, setLoadingCheck] = useState(false);

  const [isEditPurpose, setIsEditPurpose] = useState(false);
  const [isEditAmount, setIsEditAmount] = useState(false);
  const [loadingAmount, setLoadingAmount] = useState(false);
  const [loadingPeriod, setLoadingPeriod] = useState(false);
  const [isEditPeriod, setIsEditPeriod] = useState(false);
  const [loadingRemark, setLoadingRemark] = useState(false);
  const [isEditEmail, setIsEditEmail] = useState(false);

  const [formEdit, setFormEdit] = useState({
    requestamount: "" || value.requestamount,
    period: { label: value.period, value: Number(value.period) },
    email: "" || value.email,
    purpose: value?.purpose
  });

  const fileRef = useRef();

  const [error, setError] = useState();

  useEffect(() => {
    if (!showModal) return;
    queryAttachment();
    queryAttachmentLoan();
    queryRemark();
    getInterest();
  }, [showModal, value]);

  const queryRemark = async () => {
    try {
      const data = await API.get(
        "MoneyHubAdmin",
        `/loanRequest/remark/${value.phone_number}`,
        {
          queryStringParameters: {},
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        }
      );

      setForm({ ...form, remark: data.Item.remark });
    } catch (error) {
      console.log("query remark error", error);
    }
  };

  const getInterest = async () => {
    try {
      const data = await API.get("MoneyHubAdmin", `/interest`, {
        queryStringParameters: {},
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession())
            .getIdToken()
            .getJwtToken()}`,
        },
      });

      const interest = JSON.parse(data.body).Items.find(
        (rate) => rate.type === value.purpose
      );

      setInterestRate(interest.value);
    } catch (error) {
      console.log("get interest", error);
    }
  };

  const queryAttachmentLoan = async () => {
    try {
      const data = await API.get(
        "MoneyHubAdmin",
        `/loan/attachment/${value.phone_number}`,
        {
          queryStringParameters: {
            request_id: value.request_id,
          },
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        }
      );

      const signedAttachments = [];
      for (const attachment of data.Item.attachments) {
        const signedURL = await Storage.get(attachment);
        signedAttachments.push({ name: attachment, link: signedURL });
      }

      setOriAttachmentLoan(signedAttachments);
    } catch (error) {
      console.log(error);
    }
  };

  const queryAttachment = async () => {
    try {
      const data = await API.get(
        "MoneyHubAdmin",
        `/loanRequest/attachment/${value.phone_number}`,
        {
          queryStringParameters: {},
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        }
      );

      const signedAttachments = [];
      for (const attachment of data.Item.attachments) {
        const signedURL = await Storage.get(attachment);
        signedAttachments.push({ name: attachment, link: signedURL });
      }

      setCheckCreate(!!data?.Item);
      setOriAttachments(signedAttachments);
    } catch (error) {
      console.log("Query Attachment", error);
    }
  };

  const uploadAttachment = async () => {
    try {
      let attachments = [];
      if (form.attachments.length > 0) {
        const today = getCurrentLocalDateTime();
        for (const attachment of form.attachments) {
          const fileName = `${today.fullDate}_${today.hours}:${today.minutes}_${attachment?.name}`;
          const keyImg = await Storage.put(fileName, attachment);
          attachments.push(keyImg.key);
        }
      }
      if (oriAttachments.length > 0) {
        attachments = [
          ...oriAttachments.map((attachment) => attachment.name),
          ...attachments,
        ];
      }
      return attachments;
    } catch (error) {
      console.log("Upload Error Attachment", error);
    }
  };

  const onSaveAttachment = async () => {
    try {
      setLoadingSaveAttachment(true);
      const attachments = await uploadAttachment();
      if (checkCreate) {
        await API.put(
          "MoneyHubAdmin",
          `/loanRequest/attachment/${value.phone_number}`,
          {
            body: {
              attachments,
            },
            headers: {
              Authorization: `Bearer ${(await Auth.currentSession())
                .getIdToken()
                .getJwtToken()}`,
            },
          }
        );
      } else {
        await API.post("MoneyHubAdmin", `/loanRequest/attachment`, {
          body: {
            phone_number: value.phone_number,
            request_id: value.request_id,
            loan_kbank_id: value.loan_kbank_id,
            attachments,
          },
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        });
      }
    } catch (error) {
      console.log("onSaveAttachment", error);
    } finally {
      await queryAttachment();
      setLoadingSaveAttachment(false);
      setForm((prev) => {
        return {
          ...prev,
          attachments: [],
          attachmentViews: [],
        };
      });
      setCheckEdit(false);
      fileRef.current.value = "";
    }
  };

  const onDeleteAttachment = (index) => {
    const filterAttachments = oriAttachments.filter(
      (_, myIndex) => myIndex !== index
    );
    setOriAttachments(filterAttachments);
    setCheckEdit(true);
  };

  const onReturn = async () => {
    setStatus("รอผู้ยื่นคำร้องแก้ไข");
    try {
      let executeTime = getCurrentLocalDateTime();
      const result = await Swal.fire({
        title: "คุณยืนยันที่จะทำรายการหรือไม่?",
        showCancelButton: true,
        confirmButtonText: `บันทึก`,
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
        showLoaderOnDeny: false,
        preConfirm: async () => {
          if (!form.reason) {
            setError(true);
            return { error: true };
          }
          await API.put("MoneyHubAdmin", "/loanRequest", {
            body: {
              request_id: value.request_id,
              phone_number: value.phone_number, //WHERE KEY 1
              timestamp: value.timestamp, //WHERE KEY 2
              fileBuro: "",
              deviceToken: value?.deviceToken,
              reason: form.reason,
              status: "รอผู้ยื่นคำร้องแก้ไข",
              referal_one: "",
              referal_two: "",
              paydate: form.paydate,
              adminName: user.username,
              currentStatus: value?.loan_status,
              executeTime: executeTime.timestamp,
              bankBrachCode: form?.bankBrachCode
                ? form.bankBrachCode.slice(0, 4)
                : "",
              loan_kbank_id: value?.loan_kbank_id,
              purpose: formEdit.purpose,
            },
            headers: {
              Authorization: `Bearer ${(await Auth.currentSession())
                .getIdToken()
                .getJwtToken()}`,
            },
          });
        },
      });
      if (result.value?.error) {
        return await Swal.fire({
          title: "WARNING",
          text: "โปรดกรอกเหตุผลในการตีกลับ",
          icon: "warning",
          confirmButtonText: "ยืนยัน",
        });
      }
      if (!result.isConfirmed) return;
      await Swal.fire({
        title: "SUCCESS",
        text: "อัพเดตข้อมูลสำเร็จ",
        icon: "success",
        confirmButtonText: "ยืนยัน",
      });
      await getData(query);
    } catch (error) {
      console.log("Error uploading file: ", error);
      await Swal.fire({
        title: "ERROR",
        text: "Something went wrong",
        icon: "error",
        confirmButtonText: "ยืนยัน",
      });
    }
  };

  const onCancelJob = async () => {
    setStatus("ไม่ผ่าน");
    try {
      const today = new Date();
      const year = today.getFullYear();
      const month = today.getMonth();
      const date = today.getDate();
      let executeTime = getCurrentLocalDateTime();
      const result = await Swal.fire({
        title: "คุณยืนยันที่จะปฏิเสธคำขอนี้หรือไม่ ?",
        showCancelButton: true,
        confirmButtonText: `บันทึก`,
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
        showLoaderOnDeny: false,
        preConfirm: async () => {
          await API.put("MoneyHubAdmin", "/loanRequest", {
            body: {
              request_id: value.request_id,
              phone_number: value.phone_number,
              timestamp: value.timestamp,
              deviceToken: value?.deviceToken,
              fileBuro: "",
              status: "ไม่ผ่าน",
              penaltytime: new Date(
                year,
                month,
                date + 15,
                "08",
                "00",
                "00"
              ).getTime(),
              reason: form.reason || "ขอแสดงความเสียใจคำขอของคุณไม่ผ่านครับ",
              paydate: form.paydate,
              referal_one: "",
              referal_two: "",
              adminName: user.username,
              currentStatus: value?.loan_status,
              executeTime: executeTime.timestamp,
              bankBrachCode: form?.bankBrachCode
                ? form.bankBrachCode.slice(0, 4)
                : "",
              loan_kbank_id: value?.loan_kbank_id,
              purpose: formEdit.purpose,
            },
            headers: {
              Authorization: `Bearer ${(await Auth.currentSession())
                .getIdToken()
                .getJwtToken()}`,
            },
          });
        },
      });
      if (!result.isConfirmed) return;
      await Swal.fire({
        title: "SUCCESS",
        text: "อัพเดตข้อมูลสำเร็จ",
        icon: "success",
        confirmButtonText: "ยืนยัน",
      });
      await getData(query);
    } catch (error) {
      console.log("Error uploading file: ", error);
      await Swal.fire({
        title: "ERROR",
        text: "Something went wrong",
        icon: "error",
        confirmButtonText: "ยืนยัน",
      });
    }
  };

  const onCompleteJob = async () => {
    setStatus("อนุมัติ");
    try {
      const result = await Swal.fire({
        title: "คุณยืนยันที่จะอนุมัติคำขอนี้หรือไม่ ?",
        showCancelButton: true,
        confirmButtonText: `บันทึก`,
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
        showLoaderOnDeny: false,
        preConfirm: async () => {
          try {
            let errorMessage = "";
            if (!form.referal_one) {
              errorMessage += " บุคคลอ้างอิงคนที่ 1";
            }
            if (!form.referal_two) {
              errorMessage += " บุคคลอ้างอิงคนที่ 2";
            }
            if (!form.paydate) {
              errorMessage += " วันที่โอนเงิน";
            }
            if (!form.fileBuro) {
              errorMessage += " ไฟล์บูโร";
            }
            if (!form.bankBrachCode) {
              errorMessage += " รหัสสาขา";
            }
            if (!form.bankBrachCode.length > 4) {
              errorMessage += " รหัสสาขาน้อยกว่า 4 หลัก";
            }
            if (isNaN(form.bankBrachCode)) {
              errorMessage += " รหัสสาขาต้องเป็นตัวเลขเท่านั้น";
            }

            if (errorMessage) {
              setError(true);
              return { error: true, errorMessage };
            }

            let fileBuro = "";
            if (row.original.originalBuro) {
              fileBuro = row.original.originalBuro;
            } else {
              fileBuro = form.fileBuro;
              const fileName = `${new Date().getTime()}_${
                form?.fileBuro?.name
              }`;
              fileBuro = await Storage.put(fileName, form.fileBuro);
            }
            let executeTime = getCurrentLocalDateTime();

            await API.put("MoneyHubAdmin", "/loanRequest", {
              body: {
                request_id: value.request_id,
                phone_number: value.phone_number, //WHERE KEY 1
                timestamp: value.timestamp, //WHERE KEY 2
                fileBuro: fileBuro?.key ? fileBuro?.key : fileBuro,
                deviceToken: value?.deviceToken,
                reason: "",
                status: "อนุมัติ",
                currentStatus: value?.loan_status,
                // status: "ยืนยัน",
                referal_one: form.referal_one,
                referal_two: form.referal_two,
                paydate: form.paydate,
                adminName: user.username,
                executeTime: executeTime.timestamp,
                bankBrachCode: form?.bankBrachCode
                  ? form.bankBrachCode.slice(0, 4)
                  : "",
                loan_kbank_id: value?.loan_kbank_id,
                purpose: formEdit.purpose,
              },
              headers: {
                Authorization: `Bearer ${(await Auth.currentSession())
                  .getIdToken()
                  .getJwtToken()}`,
              },
            });
          } catch (error) {
            await EmitterStatus("ERROR", { logMessage: error });
          }
        },
      });
      if (result.value?.error) {
        return await EmitterStatus("WARNING", {
          text: `โปรดกรอกข้อมูล${result.value.errorMessage}`,
        });
      }
      if (!result.isConfirmed) return;
      await EmitterStatus("SUCCESS");
      await getData(query);
    } catch (error) {
      console.log("Error uploading file: ", error);
      await EmitterStatus("ERROR", { logMessage: error });
    }
  };

  const onCalling = async () => {
    setStatus("รอติดต่อบุคคลอ้างอิง");

    try {
      const result = await Swal.fire({
        title: "คุณยืนยันคำขอนี้หรือไม่ ?",
        showCancelButton: true,
        confirmButtonText: `บันทึก`,
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
        showLoaderOnDeny: false,
        preConfirm: async () => {
          let fileBuro = "";
          if (value.fileBuro) {
            fileBuro = value.originalBuro;
          } else if (form.fileBuro) {
            fileBuro = form.fileBuro;
            const fileName = `${new Date().getTime()}_${form?.fileBuro?.name}`;
            fileBuro = await Storage.put(fileName, form.fileBuro);
          }

          await API.put("MoneyHubAdmin", "/loanRequest", {
            body: {
              request_id: value.request_id,
              phone_number: value.phone_number, //WHERE KEY 1
              timestamp: value.timestamp, //WHERE KEY 2
              fileBuro: fileBuro?.key ? fileBuro.key : fileBuro,
              deviceToken: value?.deviceToken,
              reason: "",
              status: "รอติดต่อบุคคลอ้างอิง",
              paydate: form.paydate,
              currentStatus: value?.loan_status,
              referal_one: form.referal_one || false,
              referal_two: form.referal_two || false,
              adminName: user.username,
              executeTime: new Date().getTime(),
              bankBrachCode: form?.bankBrachCode
                ? form.bankBrachCode.slice(0, 4)
                : "",
              loan_kbank_id: value?.loan_kbank_id,
              purpose: formEdit.purpose,
            },
            headers: {
              Authorization: `Bearer ${(await Auth.currentSession())
                .getIdToken()
                .getJwtToken()}`,
            },
          });
          // await API.put("MoneyHubAdmin", "/overviewStatus", {
          //   body: {
          //     loan_status: "รอติดต่อบุคคลอ้างอิง",
          //     prevLoan_status: row.original.loan_status,
          //   },
          //   headers: {
          //     Authorization: `Bearer ${(await Auth.currentSession())
          //       .getIdToken()
          //       .getJwtToken()}`,
          //   },
          // });
        },
      });
      if (!result.isConfirmed) return;
      await Swal.fire({
        title: "SUCCESS",
        text: "อัพเดตข้อมูลสำเร็จ",
        icon: "success",
        confirmButtonText: "ยืนยัน",
      });
      await getData(query);
    } catch (error) {
      console.log("Error ", error);
      await Swal.fire({
        title: "ERROR",
        text: "Something went wrong",
        icon: "error",
        confirmButtonText: "ยืนยัน",
      });
    }
  };

  const onApprove = async () => {
    setStatus("รออนุมัติ");

    try {
      const result = await Swal.fire({
        title: "คุณยืนยันที่จะอนุมัติขั้นต้นคำขอนี้หรือไม่ ?",
        showCancelButton: true,
        confirmButtonText: `บันทึก`,
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
        showLoaderOnDeny: false,
        preConfirm: async () => {
          let errorMessage = "";
          if (!form.referal_one) {
            errorMessage += " บุคคลอ้างอิงคนที่ 1";
          }
          if (!form.referal_two) {
            errorMessage += " บุคคลอ้างอิงคนที่ 2";
          }
          if (!form.fileBuro) {
            errorMessage += " ไฟล์บูโร";
          }
          if (!form.bankBrachCode) {
            errorMessage += " รหัสสาขา";
          }
          if (!form.bankBrachCode.length > 4) {
            errorMessage += " รหัสสาขาน้อยกว่า 4 หลัก";
          }
          if (isNaN(form.bankBrachCode)) {
            errorMessage += " รหัสสาขาต้องเป็นตัวเลขเท่านั้น";
          }

          if (errorMessage) {
            setError(true);
            return { error: true, errorMessage };
          }

          let fileBuro = "";
          if (row.original.originalBuro) {
            fileBuro = row.original.originalBuro;
          } else {
            fileBuro = form.fileBuro;
            const fileName = `${new Date().getTime()}_${form?.fileBuro?.name}`;
            fileBuro = await Storage.put(fileName, form.fileBuro);
          }

          await API.put("MoneyHubAdmin", "/loanRequest", {
            body: {
              request_id: value.request_id,
              phone_number: value.phone_number, //WHERE KEY 1
              timestamp: value.timestamp, //WHERE KEY 2
              fileBuro: fileBuro?.key ? fileBuro.key : fileBuro,
              deviceToken: value?.deviceToken,
              reason: "",
              status: "รออนุมัติ",
              paydate: form.paydate,
              currentStatus: value?.loan_status,
              referal_one: form.referal_one,
              referal_two: form.referal_two,
              adminName: user.username,
              executeTime: new Date().getTime(),
              bankBrachCode: form?.bankBrachCode
                ? form.bankBrachCode.slice(0, 4)
                : "",
              loan_kbank_id: value?.loan_kbank_id,
              purpose: formEdit.purpose,
            },
            headers: {
              Authorization: `Bearer ${(await Auth.currentSession())
                .getIdToken()
                .getJwtToken()}`,
            },
          });
        },
      });
      if (result.value?.error) {
        return await Swal.fire({
          title: "WARNING",
          text: `โปรดกรอกข้อมูล${result.value.errorMessage}`,
          icon: "warning",
          confirmButtonText: "ยืนยัน",
        });
      }
      if (!result.isConfirmed) return;
      await Swal.fire({
        title: "SUCCESS",
        text: "อัพเดตข้อมูลสำเร็จ",
        icon: "success",
        confirmButtonText: "ยืนยัน",
      });
      await getData(query);
    } catch (error) {
      console.log("Error ", error);
      await Swal.fire({
        title: "ERROR",
        text: "Something went wrong",
        icon: "error",
        confirmButtonText: "ยืนยัน",
      });
    }
  };

  function burdenSum(jsonString) {
    try {
      var o = JSON.parse(jsonString);
      if (o && typeof o === "object") {
        var sum = 0;
        for (var i = 0; i < o.length; i++) {
          //alert(JSON.stringify(o))
          sum += o[i].payperinsallment;
        }
        return sum;
      }
    } catch (e) {}

    return 0;
  }

  function tryParseJSON(jsonString) {
    try {
      var o = JSON.parse(jsonString);
      if (o && typeof o === "object") {
        return o;
      }
    } catch (e) {}

    return jsonString.length ? jsonString : false;
  }

  const onChangeFile = async (e) => {
    const file = e.target.files[0];
    setForm((prev) => {
      return {
        ...prev,
        fileBuro: file,
      };
    });
  };

  const onChangeInput = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setForm({ ...form, [name]: value });
  };

  const onChangeCheckBox = (e) => {
    const name = e.target.name;
    const value = e.target.checked;
    setForm({ ...form, [name]: value });
  };

  const alignByIndex = (index) => {
    // if (index == 0) return "text-left";
    // if (index == 1) return "text-center";
    return "text-center";
  };

  const Asset = useCallback(({ asset }) => {
    if (asset == undefined || asset.length < 1)
      return <div className="h-4"></div>;
    return (
      <div>
        {asset?.length &&
          asset.map((data, index) => {
            return (
              <div
                key={index}
                className="border border-gray-200 bg-white p-4 flex flex-row"
              >
                <div className="w-1/2">
                  <S3Image
                    imgKey={data.img}
                    className="w-full h-auto"
                    contentType="image/jpeg"
                  />
                </div>
                <div className="w-1/2 text-right">
                  <div>
                    ประเภท{" "}
                    <span className="text-gray-700 font-bold">{data.type}</span>
                  </div>
                  <div>
                    จำนวน{" "}
                    <span className="text-gray-700 font-bold">
                      {Number(data.value).toLocaleString()}
                    </span>
                  </div>
                </div>
              </div>
            );
          })}
      </div>
    );
  }, []);

  const Debt = useCallback(({ debt }) => {
    return (
      <div>
        {debt?.length &&
          debt.map((data, index) => {
            return (
              <div key={index} className="border border-gray-200 bg-white p-4">
                <div>
                  ประเภท{" "}
                  <span className="text-gray-700 font-bold">{data.type}</span>
                </div>
                <div>
                  จำนวน{" "}
                  <span className="text-gray-700 font-bold">
                    {Number(data.amount).toLocaleString()}
                  </span>
                </div>
                <div>
                  ผ่อนต่อเดือน{" "}
                  <span className="text-gray-700 font-bold">
                    {Number(Math.ceil(data.payperinsallment)).toLocaleString()}
                  </span>
                </div>
              </div>
            );
          })}
      </div>
    );
  }, []);
  const GalleryGet = useCallback(({ paths }) => {
    if (paths.length == undefined || paths.length < 1) return <div></div>;

    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-1">
        {paths?.length &&
          paths.map((item) => {
            return <img preview="true" src={item} className="w-full h-auto" />;
          })}
      </div>
    );
  }, []);

  const Title = useCallback(({ title }) => {
    return <h3 className="mb-4 text-blueGray-800 font-black">{title}</h3>;
  }, []);

  const loginDopa = async () => {
    const { data } = await axios.post(`${baseApiDopa}/api/jwt/login`, {
      username: "Officer",
      password: "123456",
    });
    return data.token;
  };

  const postDopa = async (form) => {
    const token = localStorage.getItem("token_dopa");
    const { data } = await axios.post(
      `${baseApiDopa}/api/laser`,
      {
        pid: form.pid,
        fname: form.fname,
        lname: form.lname,
        dob: Number(form.dob),
        laser: form.laser,
      },
      {
        headers: {
          Authorization: "Bearer " + token,
        },
      }
    );
    if (data.isError || data.code !== 0) {
      await EmitterStatus("ERROR", { text: data.desc });
    } else {
      await EmitterStatus("SUCCESS", { text: data.desc });
    }
    console.log("data", data);
  };

  const setTokenDopa = (token) => {
    localStorage.setItem("token_dopa", token);
    localStorage.setItem("token_dopa_last_active", new Date().getTime());
  };

  const getDOBFormatNumber = (dob) => {
    const splitBirthDate = String(dob).split("/");
    const year = splitBirthDate[2];
    const month = splitBirthDate[1];
    const day = splitBirthDate[0];
    return Number(`${year}${month}${day}`);
  };

  const getName = (name) => {
    const splitName = String(name).split(" ");
    return {
      first_name: splitName[0],
      last_name: splitName[1],
    };
  };

  const getLaser = (hashCitizen) => {
    const hash = String(hashCitizen).split("-");
    return hash.join("");
  };

  const getFormDopaLaser = () => {
    const data = row.original;

    const form = {
      pid: Number(data.citizenid),
      fname: getName(data.name).first_name,
      lname: getName(data.name).last_name,
      dob: getDOBFormatNumber(data.birthdateTh),
      laser: getLaser(data.hashCitizen),
    };

    return form;
  };

  const onClickCheck = async () => {
    try {
      setLoadingCheck(true);
      const tokenDopa = localStorage.getItem("token_dopa");
      const lastActive = localStorage.getItem("token_dopa_last_active");
      const today = new Date().getTime();

      if (!tokenDopa) {
        const token = await loginDopa();
        setTokenDopa(token);
        await postDopa(getFormDopaLaser());
      } else {
        // expire token
        if (today - lastActive > 1000 * 60 * 20) {
          console.log("tokenDopa", tokenDopa);
          const token = await loginDopa();
          setTokenDopa(token);
        }
        getFormDopaLaser();
        await postDopa(getFormDopaLaser());
      }
    } catch (error) {
      console.log("error", error);
      await EmitterStatus("ERROR", { text: "Something went wrong" });
    } finally {
      setLoadingCheck(false);
    }
  };

  const Content = useCallback(
    ({
      title,
      value,
      textColor = "text-gray-700",
      showEdit = false,
      isEdit = false,
      onClickEdit = () => {},
    }) => {
      const onClick = () => {
        if (onClickEdit) {
          onClickEdit();
        }
      };

      return (
        <div className={"text-gray-700 flex"}>
          {title}
          <span className={textColor + " font-bold break-all	"}>
            &nbsp;{value}
          </span>
          {title === "หมายเลขบัตรประจำตัวประชาชน" && (
            <button
              disabled={loadingCheck}
              onClick={onClickCheck}
              className={classNames("ml-2 px-2 rounded text-sm", {
                "cursor-not-allowed bg-gray-400": loadingCheck,
                "bg-red-500 text-white cursor-pointer": !loadingCheck,
              })}
            >
              {loadingCheck ? "กำลังตรวจสอบ" : "ตรวจสอบ"}
            </button>
          )}
          {showEdit && (
            <div className=" px-2" onClick={onClick}>
              <div className="text-blue-500 flex items-center space-x-1 cursor-pointer">
                <Pencil className="w-4 h-4" />
                <div>Edit</div>
              </div>
            </div>
          )}
        </div>
      );
    },
    [loadingCheck]
  );

  const onClickEditAmount = () => {
    setIsEditAmount(true);
  };

  const onClickEditPeriod = () => {
    setIsEditPeriod(true);
  };

  const onClickEditEmail = () => {
    setIsEditEmail(true);
  };

  const onChangeFormEdit = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setFormEdit({ ...formEdit, [name]: value });
  };

  const onChangeSelect = (e) => {
    setFormEdit((prev) => {
      return { ...prev, period: e };
    });
  };

  const onChangeSelectPurpose = (e) => {
    setFormEdit((prev) => {
      return { ...prev, purpose: e?.value };
    });
  }
  

  const onClickSaveRemark = async () => {
    try {
      setLoadingRemark(true);
      await API.post("MoneyHubAdmin", `/loanRequest/remark`, {
        body: {
          phone_number: `${value.phone_number}`,
          request_id: value.request_id,
          loan_kbank_id: value.loan_kbank_id,
          remark: form.remark,
        },
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession())
            .getIdToken()
            .getJwtToken()}`,
        },
      });
      await Swal.fire({
        title: "SUCCESS",
        text: "อัพเดตข้อมูล Remark",
        icon: "success",
        confirmButtonText: "ยืนยัน",
      });
    } catch (error) {
      console.log("error", error);
    } finally {
      setLoadingRemark(false);
    }
  };

  const onClickCheckEmail = async () => {
    try {
      setLoadingEmail(true);

      if (!formEdit?.email) {
        return alert("โปรดกรอกอีเมลให้ถูกต้อง");
      }

      await API.put(
        "MoneyHubAdmin",
        `/loanRequest/updateAmountPeriod/${value?.request_id}`,
        {
          body: {
            type: "email",
            email: String(formEdit?.email),
          },
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        }
      );
      setIsEditEmail(false);
      // await getData(query, { isLoading: false });
    } catch (error) {
      console.log("error check amount", error);
    } finally {
      setLoadingEmail(false);
    }
  };

  const onClickCheckAmount = async () => {
    try {
      setLoadingAmount(true);

      await API.put(
        "MoneyHubAdmin",
        `/loanRequest/updateAmountPeriod/${value?.request_id}`,
        {
          body: {
            type: "requestamount",
            requestamount: Number(formEdit?.requestamount),
            payPerMonth: calPayPerMonth(
              interestRate,
              Number(formEdit.requestamount),
              Number(formEdit.period.value)
            ),
          },
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        }
      );
      setIsEditAmount(false);
      // await getData(query, { isLoading: false });
    } catch (error) {
      console.log("error check amount", error);
    } finally {
      setLoadingAmount(false);
    }
  };

  const onClickCheckPurpose = async () => {
    try {
      setLoadingAmount(true);

      const data = await API.get("MoneyHubAdmin", `/interest`, {
        queryStringParameters: {},
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession())
            .getIdToken()
            .getJwtToken()}`,
        },
      });

      const interest = JSON.parse(data.body).Items.find(
        (rate) => rate.type === formEdit.purpose
      );

      console.log("formEdit", formEdit);

      await API.put(
        "MoneyHubAdmin",
        `/loanRequest/updateAmountPeriod/${value?.request_id}`,
        {
          body: {
            type: "purpose",
            requestamount: Number(formEdit?.requestamount),
            payPerMonth: calPayPerMonth(
              interest.value,
              Number(formEdit.requestamount),
              Number(formEdit.period.value)
            ),
            purpose: formEdit.purpose,
          },
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        }
      );
      setIsEditPurpose(false);
      // await getData(query, { isLoading: false });
    } catch (error) {
      console.log("error check amount", error);
    } finally {
      setLoadingAmount(false);
    }
  };

  const onClickCheckPeriod = async () => {
    try {
      setLoadingPeriod(true);

      await API.put(
        "MoneyHubAdmin",
        `/loanRequest/updateAmountPeriod/${value?.request_id}`,
        {
          body: {
            type: "period",
            period: Number(formEdit?.period.value),
          },
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        }
      );
      setIsEditPeriod(false);
      // await getData(query, { isLoading: false });
    } catch (error) {
      console.log("error check amount", error);
    } finally {
      setLoadingPeriod(false);
    }
  };

  const onClickPurpose = () => {
    setIsEditPurpose(true);
  };

  const onClickCancelPeriod = () => {
    setIsEditPeriod(false);
    setFormEdit((prev) => {
      return {
        ...prev,
        period: { label: value.period, value: Number(value.period) },
      };
    });
  };

  const onClickCancelAmount = () => {
    setIsEditAmount(false);
    setFormEdit((prev) => {
      return {
        ...prev,
        requestamount: value.requestamount,
      };
    });
  };

  const onClickCancelEmail = () => {
    setIsEditEmail(false);
    setFormEdit((prev) => {
      return {
        ...prev,
        email: value.email,
      };
    });
  };

  const onClickCancelPurpose = () => {
    setIsEditPurpose(false);
  };

  const ContentImage = ({ value }) => {
    if (!value) return <div className="bg-gray-400 w-full h-full"></div>;

    return (
      <S3Image
        imgKey={value}
        className="w-full h-auto"
        contentType="image/jpeg"
      />
    );
    // return <img imgKey={value} className="w-full h-auto" />;
  };

  const ContentImageGet = useCallback(({ value, key }) => {
    if (!value) return <div className="bg-gray-400 w-full h-full"></div>;

    return (
      <img src={value} className="w-full h-auto" contentType="image/jpeg" />
    );
    // return <img imgKey={value} className="w-full h-auto" />;
  }, []);

  // const checkRole = () => {
  //   const roles = user.groups || [];
  //   if (!roles?.length) return false;
  //   return roles.some((role) => role === "SuperAdmin");
  // };

  const btnCompleteJob = () => {
    // if (!checkRole()) return null;

    if (
      checkRole(user.groups, [
        "SuperAdmin",
        "AnalyzeApprove",
        "ApproveSupervisor",
      ])
    ) {
      return (
        <button
          onClick={onCompleteJob}
          type="button"
          className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-green-500 text-base font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 sm:ml-3 sm:w-auto sm:text-sm"
        >
          Complete Job
        </button>
      );
    }
  };

  const btnApprove = () => {
    return (
      <button
        onClick={onApprove}
        type="button"
        className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-500 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm"
      >
        Approve
      </button>
    );
  };

  const btnCancel = () => {
    return (
      <button
        onClick={onCancelJob}
        type="button"
        className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-500 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm"
      >
        Cancel Job
      </button>
    );
  };

  const btnReturn = () => {
    return (
      <button
        onClick={onReturn}
        type="button"
        className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-pink-500 text-base font-medium text-white hover:bg-yellow-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-500 sm:ml-3 sm:w-auto sm:text-sm"
      >
        Return
      </button>
    );
  };

  const btnCalling = () => {
    return (
      <button
        onClick={onCalling}
        type="button"
        className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-orange-400 text-base font-medium text-white hover:bg-pink-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-500 sm:ml-3 sm:w-auto sm:text-sm"
      >
        Calling
      </button>
    );
  };

  const ContentFilePdf = useCallback(({ title, value }) => {
    if (value) {
      return (
        <div className="text-blue-700">
          <a target="_blank" href={`${value}`} className="w-full h-auto">
            {title}
          </a>
        </div>
      );
    }

    return <div className="text-gray-700">ไม่มีไฟล์{title}</div>;
  }, []);

  const getButtonStatus = () => {
    const loan_status = value.loan_status;
    // case "รอผู้ยื่นคำร้องแก้ไข":

    if (user.username !== row.original.reserveBy) return [];

    switch (loan_status) {
      case "รออนุมัติ":
        return [btnCompleteJob(), btnCancel(), btnCalling(), btnReturn()];
      case "รอติดต่อบุคคลอ้างอิง":
        return [btnCompleteJob(), btnApprove(), btnCancel(), btnReturn()];
      case "ไม่ผ่าน":
      case "อนุมัติ":
        return [];
      case "ยืนยัน":
        return [];
      case "สมบูรณ์":
        return [];
      default:
        return [
          btnCompleteJob(),
          btnApprove(),
          btnCancel(),
          btnCalling(),
          btnReturn(),
        ];
    }
  };

  const onChangeAttachment = (e) => {
    const files = e.target.files;
    const filesArr = Array.prototype.slice.call(e.target.files);
    setForm((prev) => {
      return { ...prev, attachmentViews: filesArr, attachments: files };
    });
    setCheckEdit(true);
  };

  const getJobAge = () => {
    const mounthCount = value.jobAge % 12;
    if (value.jobAge > 12) {
      return `${Math.floor(value.jobAge / 12)} ปี ${mounthCount} เดือน`;
    }

    return `${value.jobAge} เดือน`;
  };

  return (
    <Fragment>
      <tr
        {...row.getRowProps()}
        onClick={() => setShowModal(true)}
        className={classNames(
          "cursor-pointer hover:bg-blueGray-200 transition-all duration-300 ",
          {
            "bg-white": i % 2 === 0,
            "bg-gray-100": i % 2 !== 0,
            "bg-gray-300 hover:bg-blueGray-400 ":
              user.username === value.reserveBy,
          }
        )}
      >
        {row.cells.map((cell, index) => {
          return (
            <td
              className={"p-4 text-gray-700 text-sm " + alignByIndex(index)}
              {...cell.getCellProps()}
            >
              {cell.render("Cell")}
            </td>
          );
        })}
      </tr>
      {showModal && (
        <div
          className="fixed z-10 inset-0 overflow-y-auto"
          aria-labelledby="modal-title"
          role="dialog"
          aria-modal="true"
        >
          <div className=" h-screen  pb-20 text-center sm:p-0">
            <div className="flex-1 bg-green-500"></div>
            <div className="flex-1 bg-gray-100 rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-0  h-screen  w-full ">
              {/* เนื้อหา */}
              <div className=" flex flex-col justify-between min-h-screen">
                <div className="mx-4 pt-5 pb-4 sm:p-6 sm:pb-4 flex-1   ">
                  <div className="sm:flex sm:items-start ">
                    {/* <div className="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-blue-100 sm:mx-0 sm:h-10 sm:w-10">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-6 w-6 text-blue-500"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                        />
                      </svg>
                    </div> */}
                    <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left w-full ">
                      <h3
                        className="text-lg leading-6 font-medium text-gray-900 flex"
                        id="modal-title"
                      >
                        {value.request_id} {"  / "} {value.loan_kbank_id}{" "}
                        {" / "}
                        <span className="text-blue-500">
                          {value.loan_status}
                        </span>
                        {value?.isWarning && (
                          <span className="text-yellow-500 ml-1">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke-width="1.5"
                              stroke="currentColor"
                              class="w-6 h-6"
                            >
                              <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z"
                              />
                            </svg>
                          </span>
                        )}
                        {value.oldcustomer === "true" && (
                          <span className="ml-8 flex text-green-500 ">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="h-6 w-6 mr-2"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
                              />
                            </svg>
                            เป็นลูกค้าเก่าที่ปิดสัญญาแล้ว
                          </span>
                        )}
                      </h3>
                      {/* ส่วนแบ่งสัดส่วน  overflow-auto h-560-px 3xl:h-820-px */}
                      <div className="">
                        <div
                          className={
                            "mt-2 overflow-auto  md:min-h-screen-80   h-450-px    grid grid-cols-1 lg:grid-cols-3 gap-1"
                          }
                        >
                          <div className="p-4 bg-gray-50">
                            {Title({ title: "ข้อมูลสินเชื่อ" })}
                            {Content({
                              title: "การประเมินขั้นต้น",
                              value: value.pass === "true" ? "ผ่าน" : "ไม่ผ่าน",
                              textColor:
                                value.pass === "true"
                                  ? "text-green-500"
                                  : "text-red-500",
                            })}
                            {Content({
                              title: "คะแนน",
                              value: Math.round(value.totalScore),
                            })}

                            {isEditPurpose ? (
                              <div className="flex items-center w-full">
                                <div className={"text-gray-700 flex w-20"}>
                                  ประเภท
                                </div>
                                <Select
                                  className="w-full"
                                  options={[
                                    { label: "ธุรกิจ", value: "ธุรกิจ" },
                                    {
                                      label: "อุปโภค / บริโภค",
                                      value: "อุปโภค / บริโภค",
                                      // disabled: true,
                                    },
                                    {
                                      label: "ท่องเที่ยว",
                                      value: "ท่องเที่ยว",
                                      // disabled: true,
                                    },
                                  ]}
                                  value={{
                                    label: formEdit.purpose,
                                    value: formEdit.purpose,
                                  }}
                                  // value={formEdit?.purpose}
                                  onChange={onChangeSelectPurpose}
                                  isOptionDisabled={(option) => option.disabled}
                                />
                                <Check
                                      className="ml-2 w-4 h-4 text-green-400 cursor-pointer"
                                      onClick={onClickCheckPurpose}
                                    />
                                <Cancel
                                  className=" ml-2 mr-12 w-4 h-4 text-red-400 cursor-pointer"
                                  onClick={onClickCancelPurpose}
                                />
                              </div>
                            ) : (
                              Content({
                                title: "ประเภท",
                                value: formEdit?.purpose,
                                showEdit:
                                  value?.loan_status === "รับคำร้อง" ||
                                  value?.loan_status === "รอติดต่อบุคคลอ้างอิง",
                                onClickEdit: onClickPurpose,
                              })
                            )}

                            {isEditAmount ? (
                              <div className="flex items-center w-full">
                                <div className={"text-gray-700 flex w-64"}>
                                  วงเงินที่ได้รับ
                                </div>
                                <input
                                  className="ml-2 px-2 py-1 w-full placeholder-blueGray-400 text-gray-600 relative bg-white rounded text-sm border-0 shadow outline-none focus:outline-none focus:ring"
                                  value={formEdit.requestamount}
                                  onChange={onChangeFormEdit}
                                  name="requestamount"
                                  type="number"
                                  min={0}
                                  max={value.requestamount}
                                />
                                {loadingAmount ? (
                                  <div>Loading...</div>
                                ) : (
                                  <div className="w-full flex">
                                    <Check
                                      className="ml-2 w-4 h-4 text-green-400 cursor-pointer"
                                      onClick={onClickCheckAmount}
                                    />
                                    <Cancel
                                      className=" w-4 h-4 text-red-400 cursor-pointer"
                                      onClick={onClickCancelAmount}
                                    />
                                  </div>
                                )}
                              </div>
                            ) : (
                              Content({
                                title: "วงเงินที่ได้รับ",
                                value: `${Number(
                                  formEdit.requestamount
                                ).toLocaleString()} บาท`,
                                textColor: "text-black",
                                showEdit:
                                  value?.loan_status === "รับคำร้อง" ||
                                  value?.loan_status === "รอติดต่อบุคคลอ้างอิง",
                                onClickEdit: onClickEditAmount,
                              })
                            )}
                            {Content({
                              title: "วงเงินที่ขอ",
                              value: `${Number(
                                value?.amount
                              ).toLocaleString()} บาท`,
                            })}

                            {isEditPeriod ? (
                              <div className="flex items-center w-full">
                                <div className={"text-gray-700 flex w-64"}>
                                  ระยะเวลา
                                </div>
                                <Select
                                  className="w-full"
                                  options={[
                                    { label: "3", value: 3 },
                                    { label: "6", value: 6 },
                                    { label: "12", value: 12 },
                                    { label: "15", value: 15 },
                                    { label: "18", value: 18 },
                                    { label: "24", value: 24 },
                                  ]}
                                  value={formEdit.period}
                                  onChange={onChangeSelect}
                                />
                                {loadingPeriod ? (
                                  <div>Loading...</div>
                                ) : (
                                  <div className="w-full flex">
                                    <Check
                                      className="ml-2 w-4 h-4 text-green-400 cursor-pointer"
                                      onClick={onClickCheckPeriod}
                                    />
                                    <Cancel
                                      className=" w-4 h-4 text-red-400 cursor-pointer"
                                      onClick={onClickCancelPeriod}
                                    />
                                  </div>
                                )}
                              </div>
                            ) : (
                              Content({
                                title: "ระยะเวลา",
                                value: `${formEdit.period.value} งวด`,
                                showEdit:
                                  value?.loan_status === "รับคำร้อง" ||
                                  value?.loan_status === "รอติดต่อบุคคลอ้างอิง",
                                onClickEdit: onClickEditPeriod,
                              })
                            )}

                            {Content({
                              title: "ผ่อนต่อเดือน",
                              value: `${Number(
                                Math.ceil(
                                  interestRate
                                    ? calPayPerMonth(
                                        interestRate,
                                        Number(formEdit.requestamount),
                                        Number(formEdit.period.value)
                                      )
                                    : value.payPerMonth
                                )
                              ).toLocaleString()} บาท`,
                              textColor: "text-black",
                            })}
                            {/* {Content({
                              title: "บุคคลค้ำประกัน",
                              value:
                                value.garuntor == "{}"
                                  ? "ไม่มี"
                                  : value.garuntor,
                            })} */}
                            <div className="w-full p-3 my-2 text-gray-500 rounded-sm border border-gray-200 bg-gray-50">
                              <div>
                                ธนาคาร:{" "}
                                <span className="font-bold text-gray-700">
                                  {value.bank}
                                </span>
                              </div>
                              <div>
                                เลขที่บัญชี:{" "}
                                <span className="font-bold text-gray-700">
                                  {value.bankNo}
                                </span>
                              </div>
                              <div>
                                ชื่อบัญชี:{" "}
                                <span className="font-bold text-gray-700">
                                  {value.bankAccName}
                                </span>
                              </div>
                              <div>
                                รหัสสาขา:{" "}
                                <div>
                                  <input
                                    value={form?.bankBrachCode}
                                    maxLength={4}
                                    type="text"
                                    name="bankBrachCode"
                                    onChange={onChangeInput}
                                    className="px-3 mt-2 py-3 placeholder-blueGray-400 text-gray-600 relative bg-white rounded text-sm border-0 shadow outline-none focus:outline-none focus:ring w-full"
                                  />
                                  {error && !form.bankBrachCode && (
                                    <span className="text-red-400">
                                      โปรดกรอกรหัสสาขา
                                    </span>
                                  )}
                                </div>
                              </div>
                            </div>

                            {Content({
                              title: "สิทธ์พิเศษ",
                              value:
                                value.privillege == ""
                                  ? ""
                                  : value.privillegeType +
                                    " " +
                                    value.privillege,
                            })}

                            {value.promo != 0 && (
                              <div className="w-full p-3 mt-2 text-green-500 rounded-sm border border-green-200 bg-green-50">
                                ได้รับส่วนลดดอกเบี้ย: {value.promo} %
                              </div>
                            )}

                            {value.refinance_kbank_id != undefined &&
                              value.refinance_kbank_id != "" && (
                                <div className="w-full p-3 mt-2 text-blue-500 rounded-sm border border-blue-200 bg-blue-50">
                                  รีไฟแนนซ์มาจาก: {value.refinance_kbank_id}
                                </div>
                              )}

                            {/* {value.loan_status ===
                            "ไม่ผ่าน" ? null : value.loan_status ===
                              "อนุมัติ" ? (
                              <div className="my-3 w-full">
                                {Content({
                                  title: "วันที่โอนเงิน",
                                  value: new Intl.DateTimeFormat(
                                    "th-TH"
                                  ).format(new Date(value.paydate)),
                                })}
                              </div>
                            ) : (
                              <React.Fragment>
                                <div className="my-3 w-full">
                                  วันที่โอนเงิน
                                  <input
                                    defaultValue={format(
                                      new Date(form.paydate),
                                      "yyyy-MM-dd"
                                    )}
                                    name="paydate"
                                    className="border boder-gray-300 p-2 ml-4"
                                    type="date"
                                    onChange={onChangeInput}
                                  />
                                  {status === "อนุมัติ" ||
                                    (status === "รออนุมัติ" &&
                                      error &&
                                      !form.paydate && (
                                        <span className=" text-red-500">
                                          โปรดกรอกวันที่โอนเงิน
                                        </span>
                                      ))}
                                </div>
                              </React.Fragment>
                            )} */}
                            {value.loan_status ===
                            "อนุมัติ" ? null : value.loan_status ===
                              "ไม่ผ่าน" ? (
                              <div className="my-3 w-full">
                                {Content({
                                  title: "เหตุผลในการปฏิเสธ",
                                  value: value.reason,
                                })}
                              </div>
                            ) : (
                              <React.Fragment>
                                เหตุผลในการปฎิเสธ / ตีกลับ
                                <br />
                                <textarea
                                  name="reason"
                                  onChange={onChangeInput}
                                  value={form.reason}
                                  type="text"
                                  rows={3}
                                  placeholder="เหตุผลในการปฎิเสธ / ตีกลับ"
                                  className="px-3 mt-2 py-3 placeholder-blueGray-400 text-gray-600 relative bg-white rounded text-sm border-0 shadow outline-none focus:outline-none focus:ring w-full"
                                />
                                {status === "รอผู้ยื่นคำร้องแก้ไข" &&
                                  error &&
                                  !form.reason && (
                                    <span className=" text-red-500">
                                      โปรดกรอกเหตุผลในการปฏิเสธ
                                    </span>
                                  )}
                                <div>
                                  <div className="flex flex-col">
                                    {oriAttachments.length > 0 &&
                                      oriAttachments.map(
                                        (oriAttachment, index) => {
                                          return (
                                            <div className="flex space-x-1 items-center">
                                              <a
                                                href={oriAttachment.link}
                                                className="text-blue-500 mr-2"
                                              >
                                                {oriAttachment.name}
                                              </a>
                                              <div
                                                className="text-sm text-red-400 cursor-pointer"
                                                onClick={() =>
                                                  onDeleteAttachment(index)
                                                }
                                              >
                                                ลบ
                                              </div>
                                            </div>
                                          );
                                        }
                                      )}
                                  </div>
                                  <div className="mr-2 font-bold text-gray-700 text-base mb-2">
                                    แนบไฟล์
                                  </div>
                                  <input
                                    type="file"
                                    name="attachments"
                                    multiple="multiple"
                                    onChange={onChangeAttachment}
                                    ref={fileRef}
                                  />
                                  <div className="my-2">
                                    {form?.attachmentViews.length > 0 &&
                                      form?.attachmentViews.map(
                                        (attachmentView) => {
                                          return (
                                            <div>{attachmentView?.name}</div>
                                          );
                                        }
                                      )}
                                  </div>

                                  <button
                                    disabled={
                                      loadingSaveAttchment || !checkEdit
                                    }
                                    onClick={onSaveAttachment}
                                    className={classNames(
                                      "px-2 py-1  rounded ",
                                      {
                                        "bg-green-500 cursor-pointer text-white":
                                          !loadingSaveAttchment || checkEdit,
                                        "bg-gray-400 cursor-not-allowed":
                                          loadingSaveAttchment || !checkEdit,
                                      }
                                    )}
                                  >
                                    {loadingSaveAttchment
                                      ? "กำลังบันทึกไฟล์"
                                      : "บันทึกไฟล์"}
                                  </button>
                                </div>
                              </React.Fragment>
                            )}
                            {value.tx != undefined &&
                              value.tx != "" &&
                              Content({
                                title: "Tx (เลขอ้างอิงการโอนงิน)",
                                value: value.tx,
                                textColor: "text-green-600",
                              })}
                          </div>

                          <div className="p-4 bg-gray-50">
                            {Title({ title: "ข้อมูลส่วนบุคคล" })}
                            {Content({
                              title: "ชื่อ",
                              value: `${value.article} ${value.name} (${value.nickname})`,
                            })}

                            {Content({
                              title: "หมายเลขบัตรประจำตัวประชาชน",
                              value: value.citizenid,
                            })}

                            {Content({
                              title: "รหัสหลังบัตร",
                              value: value.hashCitizen || "-",
                            })}

                            {Content({
                              title: "วันหมดอายุบัตร",
                              value: value.citizenexpiredate,
                            })}
                            {Content({
                              title: "เพศ",
                              value: value.gender,
                            })}
                            {Content({
                              title: "วัน/เดือน/ปี เกิด",
                              value: value.birthdateTh,
                            })}
                            {Content({
                              title: "อายุ",
                              value: value.age,
                            })}
                            {Content({
                              title: "สถานภาพ",
                              value: value.marritalStatus,
                            })}
                            {value.marritalStatus == "สมรส" &&
                              Content({
                                title: "คู่สมรส",
                                value: `${value.articlePartner} ${value.namePartner} ${value.lastnamePartner}`,
                              })}

                            {Content({
                              title: "จำนวนบุตร",
                              value: value.childern,
                            })}
                            {Content({
                              title: "การศึกษา",
                              value: value.education,
                            })}

                            {/* {Content({
                              title: "ศาสนา",
                              value: value.religion,
                            })} */}
                            {Content({
                              title: "เบอร์โทรศัพท์",
                              value: value.phone_number,
                            })}
                            <ExportContactBook citizenid={value?.citizenid} />

                            {isEditEmail ? (
                              <div className="flex items-center w-full">
                                <div className={"text-gray-700 flex w-64"}>
                                  email
                                </div>
                                <input
                                  className=" -ml-16 px-3 py-2 w-full placeholder-blueGray-400 text-gray-600 relative bg-white rounded text-sm border-0 shadow outline-none focus:outline-none focus:ring"
                                  value={formEdit?.email}
                                  onChange={onChangeFormEdit}
                                  name="email"
                                  type="text"
                                />
                                {loadingEmail ? (
                                  <div>Loading...</div>
                                ) : (
                                  <div className="w-full flex">
                                    <Check
                                      className="ml-2 w-4 h-4 text-green-400 cursor-pointer"
                                      onClick={onClickCheckEmail}
                                    />
                                    <Cancel
                                      className=" w-4 h-4 text-red-400 cursor-pointer"
                                      onClick={onClickCancelEmail}
                                    />
                                  </div>
                                )}
                              </div>
                            ) : (
                              Content({
                                title: "อีเมล",
                                value: value.email,
                                showEdit: [
                                  "รอติดต่อบุคคลอ้างอิง",
                                  "รับคำร้อง",
                                  "รออนุมัติ",
                                ].includes(value?.loan_status),
                                onClickEdit: onClickEditEmail,
                              })
                            )}

                            {Content({
                              title: "ไลน์ไอดี",
                              value: value.lineid,
                            })}
                            {Content({
                              title: "ที่อยู่ตามทะเบียนบ้าน",
                              value:
                                value.addressCode +
                                " " +
                                value.addressDesc +
                                " " +
                                value.address,
                            })}
                            {Content({
                              title: "ที่อยู่ปัจจุบัน ",
                              value:
                                value.officialAddressCode +
                                " " +
                                value.officialAddressDesc +
                                " " +
                                value.currentAddress,
                            })}
                            <div className="p-4 bg-gray-50">
                              {Content({
                                title: "พิกัด ณ ตอนยื่นกู้",
                                value: value.latitude + " , " + value.longitude,
                              })}
                            </div>

                            <div className="flex flex-col">
                              ไฟล์แนบจาก Loan
                              {oriAttachmentLoan.length > 0 &&
                                oriAttachmentLoan.map(
                                  (oriAttachment, index) => {
                                    return (
                                      <div className="flex space-x-1 items-center">
                                        <a
                                          href={oriAttachment.link}
                                          className="text-blue-500 mr-2"
                                        >
                                          {oriAttachment.name}
                                        </a>
                                      </div>
                                    );
                                  }
                                )}
                            </div>
                          </div>
                          <div className="p-4 bg-gray-50">
                            {Title({ title: " ข้อมูลการเงิน" })}
                            {Content({
                              title: "คงเหลือ",
                              value: `${Number(
                                value.income - value.burden - value.burdenSum
                              ).toLocaleString()} บาท`,
                              textColor: "text-black",
                            })}
                            {Content({
                              title: "รายได้",
                              value: `${Number(
                                value.income
                              ).toLocaleString()} บาท`,
                              textColor: "text-green-600",
                            })}
                            {Content({
                              title: "รายจ่าย",
                              value: `${Number(
                                value.burden
                              ).toLocaleString()} บาท`,
                              textColor: "text-red-600",
                            })}
                            {Content({
                              title: "ยอดภาระหนี้สิน",
                              value: `${Number(
                                value.burdenSum
                              ).toLocaleString()} บาท`,
                              textColor: "text-orange-600",
                            })}
                            <div className="text-gray-700"> ภาระหนี้สิน</div>
                            <Debt debt={tryParseJSON(value?.dataDebt)} />
                            {/* <div className="text-gray-700"> ทรัพย์สิน </div>
                            <Asset asset={tryParseJSON(value?.dataAsset)} /> */}

                            <div className="border-b border-gray-300 mb-4"></div>
                            {Title({ title: " ข้อมูลการงาน" })}

                            {Content({
                              title: "อาชีพ",
                              value: value.careertype,
                            })}
                            {Content({
                              title: "สถานประกอบการ",
                              value: value.company,
                            })}
                            {Content({
                              title: "เบอร์โทรสถานประกอบการ",
                              value:
                                value.job_phone +
                                "(" +
                                value?.job_phone_ext +
                                ")",
                            })}
                            {Content({
                              title: "ที่อยู่สถานประกอบการ",
                              value: value.job_address,
                            })}
                            {Content({
                              title: "ตำแหน่งล่าสุด",
                              value: value.jobposition,
                            })}
                            {Content({
                              title: "อายุงาน",
                              value: getJobAge(),
                            })}

                            <div className="flex flex-col mt-4">
                              <div>Remark</div>
                              <textarea
                                name="remark"
                                onChange={onChangeInput}
                                value={form.remark}
                                type="text"
                                rows={3}
                                placeholder=""
                                className="px-3 mt-2 py-3 placeholder-blueGray-400 text-gray-600 relative bg-white rounded text-sm border-0 shadow outline-none focus:outline-none focus:ring w-full"
                              />
                              <button
                                disabled={loadingRemark}
                                onClick={onClickSaveRemark}
                                className={classNames(
                                  "px-2 py-1 mt-2 w-24 rounded ",
                                  {
                                    "bg-green-500 cursor-pointer text-white":
                                      !loadingRemark,
                                    "bg-gray-400 cursor-not-allowed":
                                      loadingRemark,
                                  }
                                )}
                              >
                                {loadingRemark ? "Loading..." : "Save"}
                              </button>
                            </div>
                          </div>

                          <div className="bg-gray-50 p-4">
                            {Title({ title: "ไฟล์สัญญา" })}

                            {ContentFilePdf({
                              title: "สัญญาเปิดเผยข้อมูลเครดิต",
                              value: value?.creditUri,
                            })}
                            {ContentFilePdf({
                              title: "สัญญาPDPA",
                              value: value?.pdpaUri,
                            })}
                            {/* {ContentFilePdf({
                              title: "สัญญาเงินกู้",
                              value: value?.contractUri,
                            })} */}

                            {Content({
                              title: "รหัสเปิดไฟล์",
                              value: value?.passwordPdf,
                            })}
                            {value.statementUris != undefined &&
                              value.statementUris.length > 0 &&
                              value?.statementUris?.map((document) => {
                                return (
                                  <ContentFilePdf
                                    title={document?.title}
                                    value={document?.value}
                                  />
                                );
                              })}

                            {value.loan_status === "อนุมัติ" ||
                            value.fileBuro ? (
                              ContentFilePdf({
                                title: "เอกสารเครดิตบูโร",
                                value: value.fileBuro,
                              })
                            ) : (
                              <React.Fragment>
                                {value.fileBuro &&
                                  ContentFilePdf({
                                    title: "เอกสารเครดิตบูโร",
                                    value: value.fileBuro,
                                  })}
                                <div className="text-gray-700  text-base font-medium my-2">
                                  เอกสารเครดิตบูโร
                                </div>
                                <input
                                  name="fileBuro"
                                  type="file"
                                  onChange={onChangeFile}
                                />
                                <br />
                                {status === "อนุมัติ" ||
                                  (status === "รออนุมัติ" &&
                                    error &&
                                    !form.fileBuro && (
                                      <span className=" text-red-500">
                                        โปรดแนลไฟล์เอกสารเครดิตบูโร
                                      </span>
                                    ))}
                              </React.Fragment>
                            )}
                          </div>

                          <div className="bg-gray-50 p-4">
                            {Title({ title: "บุคคลอ้างอิงลำดับที่ 1" })}
                            {Content({
                              title: "ชื่อ",
                              value: value.referalName,
                            })}
                            {Content({
                              title: "เบอร์โทรศัพท์",
                              value: value.referalPhone,
                            })}
                            {Content({
                              title: "ความสัมพันธ์",
                              value: value.relation,
                            })}
                            {Content({
                              title: "สถานที่ทำงานสำหรับบุคคลอ้างอิง",
                              value: value?.referalWork,
                            })}
                            {value.loan_status === "อนุมัติ" ? (
                              <React.Fragment>
                                <label class="inline-flex items-center">
                                  <input
                                    disabled
                                    checked
                                    type="checkbox"
                                    class="form-checkbox"
                                  />
                                  <span class="ml-2">
                                    ยืนยันบุคคลอ้างอิงลำดับที่ 1
                                  </span>
                                </label>
                              </React.Fragment>
                            ) : (
                              <React.Fragment>
                                <label class="inline-flex items-center">
                                  <input
                                    onChange={onChangeCheckBox}
                                    name="referal_one"
                                    type="checkbox"
                                    class="form-checkbox"
                                    defaultChecked={form.referal_one}
                                    value={form.referal_one}
                                  />
                                  <span class="ml-2">
                                    ยืนยันบุคคลอ้างอิงลำดับที่ 1
                                  </span>
                                </label>
                                {status === "อนุมัติ" ||
                                  (status === "รออนุมัติ" &&
                                    error &&
                                    !form.referal_one && (
                                      <div className=" text-red-500">
                                        โปรยืนยันบุคคลอ้างอิงลำดับที่ 1
                                      </div>
                                    ))}
                              </React.Fragment>
                            )}
                          </div>

                          <div className="bg-gray-50 p-4">
                            {Title({ title: "บุคคลอ้างอิงลำดับที่ 2" })}
                            {Content({
                              title: "ชื่อ",
                              value: value.referalName2,
                            })}
                            {Content({
                              title: "เบอร์โทรศัพท์",
                              value: value.referalPhone2,
                            })}
                            {Content({
                              title: "ความสัมพันธ์",
                              value: value.relation2,
                            })}
                            {Content({
                              title: "สถานที่ทำงานสำหรับบุคคลอ้างอิง",
                              value: value?.referalWork2,
                            })}
                            {value.loan_status === "อนุมัติ" ? (
                              <React.Fragment>
                                <label class="inline-flex items-center">
                                  <input
                                    disabled
                                    checked
                                    type="checkbox"
                                    class="form-checkbox"
                                  />
                                  <span class="ml-2">
                                    ยืนยันบุคคลอ้างอิงลำดับที่ 2
                                  </span>
                                </label>
                              </React.Fragment>
                            ) : (
                              <React.Fragment>
                                <label class="inline-flex items-center">
                                  <input
                                    onChange={onChangeCheckBox}
                                    name="referal_two"
                                    type="checkbox"
                                    class="form-checkbox"
                                    defaultChecked={form.referal_two}
                                    value={form.referal_two}
                                  />
                                  <span class="ml-2">
                                    ยืนยันบุคคลอ้างอิงลำดับที่ 2
                                  </span>
                                </label>

                                {status === "อนุมัติ" ||
                                  (status === "รออนุมัติ" &&
                                    error &&
                                    !form.referal_two && (
                                      <div className=" text-red-500">
                                        โปรดยืนยันบุคคลอ้างอิงลำดับที่ 2
                                      </div>
                                    ))}
                              </React.Fragment>
                            )}
                          </div>

                          <div className="col-start-1 col-end-1 lg:col-end-4 bg-gray-50 pt-4  grid grid-cols-1 lg:grid-cols-4 gap-1">
                            <div className="text-center col-span-2">
                              {Title({
                                title:
                                  "ภาพบัตรประจำตัวประชาชน/ข้าราชการ/ใบเปลี่ยนชื่อ",
                              })}
                              <Gallery
                                paths={tryParseJSON(value?.citizenUri)}
                                max="grid-cols-2 "
                              />
                            </div>
                            <div className="text-center">
                              {Title({ title: "ภาพถ่ายหน้าตรง" })}
                              {ContentImage({ value: value.selfieUri })}
                            </div>

                            {/* <div className="text-center">
                              {Title({ title: "ภาพทะเบียนบ้าน" })}
                              {ContentImage({ value: value.addressUri })}
                            </div> */}
                            <div className="text-center">
                              {Title({ title: "ภาพสมุดบัญชี" })}
                              {ContentImage({ value: value.bookbankUri })}
                            </div>
                          </div>

                          <div className="col-start-1 col-end-1 lg:col-end-4 bg-gray-50 pt-4  grid grid-cols-1 lg:grid-cols-4 gap-1">
                            <div className="w-full text-center font-bold text-lg col-span-4">
                              ภาพจากตอนสมัคร
                            </div>
                            <div className="text-center col-span-2">
                              {Title({
                                title:
                                  "ภาพบัตรประจำตัวประชาชน/ข้าราชการ/ใบเปลี่ยนชื่อ",
                              })}
                              <GalleryGet paths={value?.get_citizenUri} />
                            </div>
                            <div className="text-center">
                              {Title({ title: "ภาพถ่ายหน้าตรง" })}
                              {ContentImageGet({
                                value: value.get_selfieUri,
                                key: "selfie.jpeg",
                              })}
                            </div>

                            {/* <div className="text-center">
                              {Title({ title: "ภาพทะเบียนบ้าน" })}
                              {ContentImageGet({
                                value: value.get_addressUri,
                                key: "address.jpeg",
                              })}
                            </div> */}
                            <div className="text-center">
                              {Title({ title: "ภาพสมุดบัญชี" })}
                              {ContentImageGet({
                                value: value.get_bookbankUri,
                                key: "bookbank.jpeg",
                              })}
                            </div>
                          </div>

                          <div className="col-start-1 col-end-1 lg:col-end-4 bg-gray-50 pt-4">
                            <div className="text-center">
                              {Title({ title: "หนังสือรับรองเงินเดือน" })}
                              <Gallery
                                canRotate={true}
                                paths={tryParseJSON(value?.slipUris)}
                              />
                            </div>
                          </div>

                          <div className="col-start-1 col-end-1 lg:col-end-4 bg-gray-50 pt-4">
                            <div className="text-center">
                              {Title({ title: "แผนธุรกิจ" })}
                              <Gallery
                                paths={tryParseJSON(
                                  value?.businessContractUris
                                )}
                              />
                            </div>
                          </div>

                          <div className="col-start-1 col-end-1 lg:col-end-4 bg-gray-50 pt-4">
                            <div className="text-center">
                              {Title({ title: "บิล/ใบเสร็จ ค่าโทรศัพท์" })}
                              {value?.statementUrisMobile?.length > 0 && (
                                <Gallery
                                  paths={tryParseJSON(
                                    value?.statementUrisMobile
                                  )}
                                />
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* แผงปุ่มด้านล่างสุด */}

                <div className="bg-gray-50  my-1 text-center border-t border-gray-300  ">
                  <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse   ">
                    <React.Fragment>
                      {getButtonStatus().map((element, index) => {
                        return element;
                      })}
                      <button
                        onClick={() => setShowModal(false)}
                        type="button"
                        className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                      >
                        Back
                      </button>
                    </React.Fragment>
                    {/* )} */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
};

function LoanRequestTable({ data, getData, query, setSelectedRows }) {
  const getStyleStatus = (status) => {
    switch (status) {
      case "อนุมัติ":
        return "text-green-400";
      case "รออนุมัติ":
        return "text-yellow-500";
      case "ไม่ผ่าน":
        return "text-red-500";
      case "รอผู้ยื่นคำร้องแก้ไข":
        return "text-pink-500";
      case "รับคำร้อง":
        return "text-gray-300";
      case "รอติดต่อบุคคลอ้างอิง":
        return "text-orange-400";
      case "ยืนยัน":
        return "text-purple-400";
      case "สมบูรณ์":
        return "text-green-600";
      default:
        console.log("UNKNOWN STATUS", status);
        break;
    }
  };

  const getDisabledCheckbox = (loan_status, fileBuro) => {
    // if (!fileBuro) return true;
    // switch (loan_status) {
    //   case "อนุมัติ":
    //   case "ไม่ผ่าน":
    //   case "ยืนยัน":
    //   case "สมบูรณ์":
    //   case "สิ้นสุด":
    //     return true;
    //   default:
    //     return false;
    // }
  };

  const columns = useMemo(
    () => [
      {
        Header: "Job. No.",
        accessor: "loan_kbank_id",
      },
      {
        Header: "ชื่อ",
        accessor: "name",
      },
      {
        Header: "วงเงินที่ได้",
        accessor: "requestamount",
        Cell: ({ row }) => {
          return <div>{numeral(row.values.requestamount).format("0,0")}</div>;
        },
      },
      {
        Header: "วงเงินที่ขอ",
        accessor: "amount",
        Cell: ({ row }) => {
          return <div>{numeral(row.values.amount).format("0,0")}</div>;
        },
      },
      {
        Header: "ประเภทสินเชื่อ",
        accessor: "purpose",
      },

      {
        Header: "วันที่สร้าง",
        accessor: "timestamp",
        Cell: ({ row }) => {
          return (
            <div>{format(new Date(row.values.timestamp), "dd-MM-yyyy")}</div>
          );
        },
      },
      {
        Header: "วันที่แก้ไข",
        accessor: "executeTime",
        Cell: ({ row }) => {
          if (!row.values?.executeTime) return <div>-</div>;
          return (
            <div>{format(new Date(row.values.executeTime), "dd-MM-yyyy")}</div>
          );
        },
      },
      {
        Header: "สถานะ",
        accessor: "loan_status",
        Cell: ({ row }) => {
          return (
            <div
              className={classNames(
                `${getStyleStatus(
                  row.values.loan_status
                )} py-1 px-0 rounded-md `
              )}
            >
              {row.values.loan_status}
            </div>
          );
        },
      },
      {
        Header: "Time Remain",
        accessor: "dueTime",
        Cell: ({ row }) => {
          if (["ไม่ผ่าน", "อนุมัติ"].includes(row.values.loan_status)) {
            return <div>สิ้นสุด</div>;
          }
          if (
            ["ยืนยัน", "สมบูรณ์", "สิ้นสุด"].includes(row.values.loan_status)
          ) {
            return <div>-</div>;
          }

          return (
            <Countdown
              date={
                Date.now() +
                (new Date(row.values.dueTime).getTime() - Date.now())
              }
            />
          );
        },
      },
      {
        Header: "จองโดย",
        accessor: "reserveBy",
        Cell: ({ row }) => {
          return (
            <div className="text-black font-medium">{row.values.reserveBy}</div>
          );
        },
      },
      {
        Header: "แก้ไขโดย",
        accessor: "adminName",
      },
    ],
    []
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    selectedFlatRows,
    toggleAllRowsSelected,
  } = useTable(
    {
      columns,
      data,
    },
    useRowSelect,
    (hooks) => {
      hooks.visibleColumns.push((columns) => [
        {
          id: "selection",
          Header: ({
            flatRows,
            getToggleAllRowsSelectedProps,
            toggleRowSelected,
            rows,
            ...props
          }) => {
            const onChangeAll = (e) => {
              flatRows.forEach((row) => {
                const { loan_status, fileBuro } = row.original;
                // if (
                //   loan_status !== "อนุมัติ" &&
                //   loan_status !== "ไม่ผ่าน" &&
                //   loan_status !== "สมบูรณ์" &&
                //   loan_status !== "ยืนยัน" &&
                //   loan_status !== "สิ้นสุด"
                // ) {
                // if (fileBuro) {
                toggleRowSelected(row.id, e.target.checked);
                // }
                // }
              });
            };

            return (
              <div>
                <IndeterminateCheckbox
                  onChange={onChangeAll}
                  flatRows={flatRows}
                  id="ALL"
                  // disabled={rows.every((row) =>
                  //   getDisabledCheckbox(
                  //     row.original.loan_status,
                  //     row.original.fileBuro
                  //   )
                  // )}
                  // {...getToggleAllRowsSelectedProps()}
                />
              </div>
            );
          },
          Cell: ({
            row,
            toggleRowSelected,
            selectedFlatRows,
            flatRows,
            ...props
          }) => {
            const loan_status = row.original.loan_status;
            const fileBuro = row.original.fileBuro;

            return (
              <div className="pointer-events-auto cursor-pointer">
                <IndeterminateCheckbox
                  selectedFlatRows={selectedFlatRows}
                  flatRows={flatRows}
                  onClick={(e) => e.stopPropagation()}
                  {...row.getToggleRowSelectedProps()}
                  // disabled={getDisabledCheckbox(loan_status, fileBuro)}
                />
              </div>
            );
          },
        },
        ...columns,
      ]);
    }
  );

  useEffect(() => {
    setSelectedRows(selectedFlatRows);
  }, [selectedFlatRows]);

  return (
    <div className="mx-4 mb-2">
      <div className="bg-white rounded border border-gray-300 w-full overflow-x-auto ">
        <table {...getTableProps()} className="w-full whitespace-no-wrap">
          <thead className=" text-sm font-semibold tracking-wide text-gray-500  border-b dark:border-gray-700 bg-gray-50 dark:text-gray-400 dark:bg-gray-800">
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column, i) => (
                  <th
                    {...column.getHeaderProps()}
                    className={classNames("px-4 py-3 text-center", {
                      "rounded-tl": i === 0,
                      "rounded-tr": i === headerGroup.headers.length - 1,
                    })}
                  >
                    {column.render("Header")}
                    <span>
                      {" "}
                      {column.isSorted ? (
                        column.isSortedDesc ? (
                          <FontAwesomeIcon icon={faAngleDown} />
                        ) : (
                          <FontAwesomeIcon icon={faAngleUp} />
                        )
                      ) : (
                        ""
                      )}
                    </span>
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody
            className="bg-white divide-y dark:divide-gray-700 dark:bg-gray-800 text-gray-700 dark:text-gray-400"
            {...getTableBodyProps()}
          >
            {rows.map((row, i) => {
              prepareRow(row);
              return (
                <Row
                  query={query}
                  key={row.getRowProps().key}
                  i={i}
                  row={row}
                  value={data[i]}
                  getData={getData}
                />
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default LoanRequestTable;
